export const passShouldNotContainUser = (username, password) => {
  if (!username || !password) return true

  // eslint-disable-next-line no-useless-escape
  const REGEX_SPECIAL_CHAR = /[\!\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g

  const user = username.replace(REGEX_SPECIAL_CHAR, '\\$&').toLowerCase()

  const slicedUsername = user.match(/.{3}/g).concat(
    user.substr(1).match(/.{3}/g),
    user.substr(2).match(/.{3}/g)
  )

  return new RegExp(slicedUsername.join('|'), 'i').test(password.toLowerCase())
}
